module.exports = __webpack_public_path__ + "static/media/privacy_footer_icon.160cea4b.svg";